import React from "react";
import { Container } from "reactstrap";
import "./ContainerLayout.scss";

const ContainerLayout = ({ children, classes }) => {
  return (
    <Container fluid className="container-layout" style={{...classes}}>
      {children}
    </Container>
  );
};

export default ContainerLayout;
